export default __webpack_public_path__ + "static/media/flying-laptop-mobile-tablet-3d-rendering-showing-builder-website-responsive-web-design@2x.34130939.png";